export default function BackgroundBlobs() {
  return (
    <div aria-hidden className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
      <div
        className="bg-blob animate-blob-drift"
        style={{
          top: "-160px", left: "-160px",
          width: "520px", height: "520px",
          background: "radial-gradient(circle, #60A5FA 0%, transparent 70%)",
        }}
      />
      <div
        className="bg-blob animate-blob-drift"
        style={{
          bottom: "-200px", right: "-200px",
          width: "620px", height: "620px",
          background: "radial-gradient(circle, #93C5FD 0%, transparent 70%)",
          animationDelay: "-6s",
        }}
      />
      <div
        className="bg-blob animate-blob-drift"
        style={{
          top: "40%", left: "55%",
          width: "420px", height: "420px",
          background: "radial-gradient(circle, #CBD5E1 0%, transparent 70%)",
          opacity: 0.35,
          animationDelay: "-12s",
        }}
      />
    </div>
  );
}
